import classNames from "classnames";
import { ReactNode } from "react";
import { YesNoType } from "types/YesNoType";
import { tagSizeConfig, tagThemeConfig } from "./constants";

type TagVariant = Exclude<YesNoType, null> | "DEFAULT" | "SELECTED";
type TagSize = "sm" | "default" | "lg";

export type TagProps = {
  label: string | number | ReactNode;
  icon?: string | ReactNode;
  size?: TagSize;
  variant?: TagVariant;
  selected?: boolean;
  dismissable?: boolean;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  className?: string;
  onDismiss?: () => void;
};

const Tag = ({
  label,
  icon,
  size = "default",
  variant = "DEFAULT",
  selected = false,
  dismissable = false,
  onClick,
  onDismiss,
  className,
  ...otherProps
}: TagProps) => {
  const styleConfig = tagThemeConfig[selected ? "SELECTED" : variant];
  const sizeConfig = tagSizeConfig[size];

  const { themeStyles } = styleConfig;
  const { sizeStyles } = sizeConfig;

  return (
    <span
      data-testid="tag"
      onClick={onClick}
      className={classNames(
        "inline-flex items-center justify-center whitespace-nowrap overflow-hidden uppercase align-middle",
        onClick && "cursor-pointer",
        // Theme-based classes
        themeStyles,
        sizeStyles,
        // Custom classes
        className
      )}
      {...otherProps}
    >
      {typeof icon === "string" ? (
        <i
          className={classNames(
            icon,
            "inline-flex h-4 w-4 items-center justify-center bold-icon"
          )}
        />
      ) : icon ? (
        icon
      ) : null}
      {label}
      {dismissable && (
        <i
          data-testid="tag-dismiss"
          className={classNames(
            "icon-x text-fg-muted inline-flex h-4 w-4 items-center justify-center bold-icon",
            onDismiss && "cursor-pointer"
          )}
          onClick={onDismiss}
        />
      )}
    </span>
  );
};

export default Tag;
